var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad" },
    [
      _c("div", { staticClass: "marginTop" }),
      _c("p", { staticClass: "labelDivider" }, [_vm._v("Dados do cônjuge")]),
      _c("div", { staticClass: "tittle" }),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required|cpf",
                  name: _vm.nomeAba + "/Conjuge - CPF"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "CPF:" } }),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "###.###.###-##",
                              expression: "'###.###.###-##'"
                            }
                          ],
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "CPF" },
                          model: {
                            value: _vm.pessoa.cpf,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoa, "cpf", $$v)
                            },
                            expression: "pessoa.cpf"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 16 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: _vm.nomeAba + "/Conjuge - Nome"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "Nome:" } }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "Nome", maxlength: "300" },
                          on: {
                            input: function($event) {
                              return _vm.toUppercase($event, "pessoa", "nome")
                            }
                          },
                          model: {
                            value: _vm.pessoa.nome,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoa, "nome", $$v)
                            },
                            expression: "pessoa.nome"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.isProcessoFisico
        ? _c(
            "el-row",
            { staticClass: "labelDiv", attrs: { gutter: 30 } },
            [
              _vm.isProcessoFisico
                ? _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: _vm.nomeAba + "/Conjuge/Tipo de documento"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: "Tipo de documento:",
                                      required: false
                                    }
                                  }),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "input select",
                                      class: { erro: errors.length },
                                      attrs: {
                                        name: "Tipo de documento",
                                        "value-key": "codigo",
                                        "no-match-text":
                                          "Nenhum tipo de documento não encontrado",
                                        placeholder: "Selecione",
                                        clearable: "clearable",
                                        filterable: "filterable"
                                      },
                                      model: {
                                        value: _vm.pessoa.tipoDocumento,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.pessoa,
                                            "tipoDocumento",
                                            $$v
                                          )
                                        },
                                        expression: "pessoa.tipoDocumento"
                                      }
                                    },
                                    _vm._l(_vm.tipoDocumentos, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: { label: item, value: item }
                                      })
                                    }),
                                    1
                                  ),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1889906367
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.pessoa.tipoDocumento == "OUTROS"
                ? _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: _vm.nomeAba + "/Conjuge/OutrosTipoDocumento"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: { label: "Outros:", required: true }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: { name: "Outros", maxlength: "30" },
                                    on: {
                                      input: function($event) {
                                        return _vm.toUppercase(
                                          $event,
                                          "pessoa",
                                          "outrosTipoDocumento"
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.pessoa.outrosTipoDocumento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.pessoa,
                                          "outrosTipoDocumento",
                                          $$v
                                        )
                                      },
                                      expression: "pessoa.outrosTipoDocumento"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          367115231
                        )
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      !_vm.isViuvo
        ? _c(
            "el-row",
            { staticClass: "labelDiv", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: !_vm.isProcessoFisico ? "required" : "",
                      name: _vm.nomeAba + "/Conjuge - RG"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "RG:",
                                  required: !_vm.isProcessoFisico
                                }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: { name: "RG", maxlength: "30" },
                                on: {
                                  input: function($event) {
                                    return _vm.toUppercase(
                                      $event,
                                      "pessoa",
                                      "rg"
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.pessoa.rg,
                                  callback: function($$v) {
                                    _vm.$set(_vm.pessoa, "rg", $$v)
                                  },
                                  expression: "pessoa.rg"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2861280847
                    )
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: !_vm.isProcessoFisico ? "required" : "",
                      name: _vm.nomeAba + "/Conjuge - Órgão Expedidor"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Órgão expedidor:",
                                  required: !_vm.isProcessoFisico
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticClass: "input select",
                                  class: { erro: errors.length },
                                  attrs: {
                                    name: "Órgão expedidor",
                                    "no-match-text": "Nenhum orgão encontrado",
                                    placeholder: "Selecione",
                                    "value-key": "id",
                                    filterable: "filterable",
                                    clearable: "clearable"
                                  },
                                  on: { change: _vm.setOrgaoCodigo },
                                  model: {
                                    value: _vm.pessoa.orgaoExpedidor.nome,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.pessoa.orgaoExpedidor,
                                        "nome",
                                        $$v
                                      )
                                    },
                                    expression: "pessoa.orgaoExpedidor.nome"
                                  }
                                },
                                _vm._l(_vm.orgaosExpedidores, function(
                                  orgaoExpedidor
                                ) {
                                  return _c("el-option", {
                                    key: orgaoExpedidor.id,
                                    attrs: {
                                      label: orgaoExpedidor.nome,
                                      value: orgaoExpedidor.nome
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4110501358
                    )
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: !_vm.isProcessoFisico ? "required" : "",
                      name: _vm.nomeAba + "/Conjuge - UF do RG"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "UF do RG:",
                                  required: !_vm.isProcessoFisico
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticClass: "input select",
                                  class: { erro: errors.length },
                                  attrs: {
                                    name: "UF do RG",
                                    "no-match-text": "Nenhuma UF encontrada",
                                    placeholder: "Selecione",
                                    clearable: "clearable",
                                    filterable: "filterable",
                                    disabled: !_vm.pessoa.orgaoExpedidor.nome
                                  },
                                  model: {
                                    value: _vm.pessoa.orgaoExpedidor.estado,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.pessoa.orgaoExpedidor,
                                        "estado",
                                        $$v
                                      )
                                    },
                                    expression: "pessoa.orgaoExpedidor.estado"
                                  }
                                },
                                _vm._l(_vm.estadosBr, function(estado) {
                                  return _c("el-option", {
                                    key: estado.codigo,
                                    attrs: {
                                      label: estado.nome,
                                      value: estado.codigo
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      387717986
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._t("slotContato"),
      !_vm.isViuvo && !_vm.isProcessoFisico
        ? _c(
            "el-row",
            { staticClass: "labelDiv", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: _vm.nomeAba + "/Conjuge - Nacionalidade"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: { label: "Nacionalidade:" }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticClass: "input select",
                                  class: { erro: errors.length },
                                  attrs: {
                                    name: "Nacionalidade",
                                    "no-match-text":
                                      "Nenhuma nacionalidade encontrada",
                                    placeholder: "Selecione",
                                    "value-key": "id",
                                    clearable: "clearable",
                                    filterable: "filterable"
                                  },
                                  on: { change: _vm.changeNacionalidade },
                                  model: {
                                    value: _vm.pessoa.nacionalidade,
                                    callback: function($$v) {
                                      _vm.$set(_vm.pessoa, "nacionalidade", $$v)
                                    },
                                    expression: "pessoa.nacionalidade"
                                  }
                                },
                                _vm._l(_vm.gentilico, function(item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label:
                                        item.gentilico + " - " + item.nomePais,
                                      value: item.sigla
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3065909365
                    )
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: _vm.ufAndMunicipioRequired(),
                      name: _vm.nomeAba + "/Conjuge - UF de Naturalidade"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "UF de naturalidade:",
                                  required: _vm.isBrasileiro
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticClass: "input select",
                                  class: { erro: errors.length },
                                  attrs: {
                                    "no-match-text": "Nenhuma UF encontrada",
                                    placeholder: "Selecione",
                                    clearable: "clearable",
                                    filterable: "filterable",
                                    disabled: !_vm.isBrasileiro,
                                    name: "UF de Naturalidade"
                                  },
                                  on: { change: _vm.setMunicipioUf },
                                  model: {
                                    value: _vm.pessoa.ufNaturalidade,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.pessoa,
                                        "ufNaturalidade",
                                        $$v
                                      )
                                    },
                                    expression: "pessoa.ufNaturalidade"
                                  }
                                },
                                _vm._l(_vm.estadosBr, function(item) {
                                  return _c("el-option", {
                                    key: item.codigo,
                                    attrs: {
                                      label: item.nome,
                                      value: item.codigo
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3598957760
                    )
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: _vm.ufAndMunicipioRequired(),
                      name: _vm.nomeAba + "/Conjuge - Município de Naturalidade"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Município de naturalidade:",
                                  required: _vm.isBrasileiro
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticClass: "input select",
                                  class: { erro: errors.length },
                                  attrs: {
                                    name: "Município de Naturalidade",
                                    "no-match-text":
                                      "Nenhum município encontrado",
                                    placeholder: "Selecione",
                                    filterable: "filterable",
                                    disabled: !_vm.isBrasileiro,
                                    "value-key": "id"
                                  },
                                  model: {
                                    value: _vm.pessoa.naturalidade,
                                    callback: function($$v) {
                                      _vm.$set(_vm.pessoa, "naturalidade", $$v)
                                    },
                                    expression: "pessoa.naturalidade"
                                  }
                                },
                                _vm._l(_vm.municipios, function(item) {
                                  return _c("el-option", {
                                    key: item.nome,
                                    attrs: { label: item.nome, value: item }
                                  })
                                }),
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3526208837
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.isViuvo && !_vm.isProcessoFisico
        ? _c(
            "el-row",
            { attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: _vm.nomeAba + "/Conjuge - Data de nascimento"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Data de nascimento:",
                                  required: true
                                }
                              }),
                              _c("el-date-picker", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: "##/##/#####",
                                    expression: "'##/##/#####'"
                                  }
                                ],
                                staticClass: "input full-width",
                                class: { erro: errors.length },
                                attrs: {
                                  type: "date",
                                  name: "Data de nascimento",
                                  placeholder: "Selecione",
                                  format: "dd/MM/yyyy",
                                  "picker-options": _vm.pickerOptions
                                },
                                model: {
                                  value: _vm.pessoa.dataNascimento,
                                  callback: function($$v) {
                                    _vm.$set(_vm.pessoa, "dataNascimento", $$v)
                                  },
                                  expression: "pessoa.dataNascimento"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2901441668
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isViuvo
        ? _c(
            "el-row",
            { attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: _vm.nomeAba + "/Conjuge - Possui certidão de óbito"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Possui certidão de óbito? ",
                                  required: true
                                }
                              }),
                              _c(
                                "el-radio-group",
                                {
                                  staticClass: "radio-group",
                                  class: { erro: errors[0] },
                                  attrs: { name: "Cônjuge possui certidão?" },
                                  model: {
                                    value: _vm.pessoa.possuiCertidaoObito,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.pessoa,
                                        "possuiCertidaoObito",
                                        $$v
                                      )
                                    },
                                    expression: "pessoa.possuiCertidaoObito"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "radio",
                                      attrs: { label: true }
                                    },
                                    [_vm._v("Sim")]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "radio",
                                      attrs: { label: false }
                                    },
                                    [_vm._v("Não")]
                                  )
                                ],
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      53012613
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82c9dffe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82c9dffe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDadosConjuge.vue
// module id = null
// module chunks = 